/***************************************************************************************************

 Copyright 2023-2024 Fannie Mae. All rights reserved.
 This software contains confidential information and trade secrets of Fannie Mae.
 Use, disclosure, or reproduction is prohibited without the prior written consent of Fannie Mae.

 ****************************************************************************************************/

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserDetails } from "../model/UserDetails";
import { ApiService } from "../services/api.service";
import { AppConstants } from "../shared/app.constants";
import { UserRolesService } from '../services/user-roles.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})

export class HomeComponent implements OnInit {
  homeTitle: string;
  homeUnauthorizedMessage: string;
  userDetails: UserDetails;
  showDueDiligenceDashboard = false;
  showInsurance = false;

  // client: LDClient.LDClient;
  systemDownFlagValue = {};
  showSystemDown = false;

  public constructor(
    private router: Router,
    private userRolesService: UserRolesService,
    private apiService: ApiService) {
  }

  ngOnInit() {
    if (this.apiService.shutDownApp) {
      return;
    }

    //Set constants
    this.homeTitle = AppConstants.HOME_TITLE;
    this.homeUnauthorizedMessage = AppConstants.HOME_UNAUTHORIZED_MESSAGE;

    this.userDetails = this.apiService.getUserDetails();
    if (this.userDetails) {
      this.showDueDiligenceDashboard = this.userRolesService.isShowDueDiligenceDashboard(this.userDetails)
      this.showInsurance = this.userRolesService.isShowInsuranceDashboard(this.userDetails);
        }

    this.defaultRoute();
  }

  defaultRoute() {
    if (this.showDueDiligenceDashboard) {
      this.router.navigate(['/dd_dashboard'], { skipLocationChange: true });
    } else if (this.showInsurance) {
      this.router.navigate(['/insurance'], { skipLocationChange: true });
    } else {
      this.router.navigate(['/un-authorized'], { skipLocationChange: true });
    }
  }
}
